<script>
import Dropdown from '@/components/atoms/Dropdown'
import { mapGetters } from 'vuex'
import { EventBus } from '@/modules/plugins/modules/event'

export default {
    name: 'LanguageSelector',
    components: { Dropdown },
    computed: {
        ...mapGetters(['locales', 'locale', 'smDevice', 'languageSelectorAvailable']),
    },
    methods: {
        setLanguage(locale) {
            this.$refs.dropdown?.close()
            this.$store.dispatch('localeSet', locale).finally(() => {
                EventBus.$emit('language')
            })
        },
    },
}
</script>

<template lang="pug">
dropdown.mr-3(v-if="languageSelectorAvailable" ref="dropdown" :disabled="!locales" :xs="smDevice") {{ locale }}
    template(v-slot:content)
        button(v-for="option in locales" @click="setLanguage(option)" :key="`lang-${option}`" :class="['btn-language', {'selected': option === locale}]") {{$t(`base.languages.${option}`)}}
</template>
